import go from 'gojs' /* eslint-disable */

export function diagramInit(scriptData) {
var $ = go.GraphObject.make
var myDiagram = $( // create a Diagram for the DIV id = editorBlock
  go.Diagram,
  'editorBlock', {
    LinkDrawn: showLinkLabel,
    LinkRelinked: showLinkLabel,
    'undoManager.isEnabled': true
    // 'ModelChanged': function(e) {
    //   if (e.isTransactionFinished) {
    //     document.getElementById("savedModel").textContent = myDiagram.model.toJson()
    //   }
  }
)

myDiagram.addDiagramListener('Modified', function(e) {
  var button = document.getElementById('SaveButton')
  if (button) button.disabled = !myDiagram.isModified
  var idx = document.title.indexOf('*')
  if (myDiagram.isModified) {
    if (idx < 0) document.title += '*'
  } else {
    if (idx >= 0) document.title = document.title.substr(0, idx)
  }
})


// ! ------------ LOCATION
function nodeStyle() {
  return [
    new go.Binding('location', 'loc', go.Point.parse).makeTwoWay(
      go.Point.stringify
    ),
    {
      locationSpot: go.Spot.Center
    }
  ]
}

// ! ------------  ПОРТЫ
function makePort(name, align, spot, output, input) {
        var horizontal = align.equals(go.Spot.Top) || align.equals(go.Spot.Bottom);
        // the port is basically just a transparent rectangle that stretches along the side of the node,
        // and becomes colored when the mouse passes over it
        return $(go.Shape,
          {
            fill: "transparent",  // changed to a color in the mouseEnter event handler
            strokeWidth: 0,  // no stroke
            width: horizontal ? NaN : 8,  // if not stretching horizontally, just 8 wide
            height: !horizontal ? NaN : 8,  // if not stretching vertically, just 8 tall
            alignment: align,  // align the port on the main Shape
            stretch: (horizontal ? go.GraphObject.Horizontal : go.GraphObject.Vertical),
            portId: name,  // declare this object to be a "port"
            fromSpot: spot,  // declare where links may connect at this port
            fromLinkable: output,  // declare whether the user may draw links from here
            toSpot: spot,  // declare where links may connect at this port
            toLinkable: input,  // declare whether the user may draw links to here
            cursor: "pointer",  // show a different cursor to indicate potential link point
            mouseEnter: function(e, port) {  // the PORT argument will be this Shape
              if (!e.diagram.isReadOnly) port.fill = "rgba(255,0,255,0.5)";
            },
            mouseLeave: function(e, port) {
              port.fill = "transparent";
            }
          });
      }

      function textStyle() {
        return {
          font: "normal 11pt Lato, Helvetica, Arial, sans-serif",
          stroke: "#000000"
        }
      }

// ! ----------- ШАБЛОНЫ УЗЛОВ

//! -----дефолтный шаблон
myDiagram.nodeTemplateMap.add(
  '',
  $(
    go.Node,
    'Table',
    nodeStyle(),
    $(
      go.Panel,
      'Auto',
      $(
        go.Shape,
        'Rectangle', {
          fill: 'transparent',
          stroke: '#00A9C9',
          strokeWidth: 1.5
        },
        new go.Binding('figure', 'figure')
      ),
      $(
        go.TextBlock,
        textStyle(), {
          margin: 8,
          maxSize: new go.Size(160, NaN),
          wrap: go.TextBlock.WrapFit,
          editable: true
        },
        new go.Binding('text').makeTwoWay()
      )
    ),
    makePort('T', go.Spot.Top, go.Spot.TopSide, false, true),
    makePort('L', go.Spot.Left, go.Spot.LeftSide, true, true),
    makePort('R', go.Spot.Right, go.Spot.RightSide, true, true),
    makePort('B', go.Spot.Bottom, go.Spot.BottomSide, true, false)
  )
)

//!------шаблон для реплики оператора
myDiagram.nodeTemplateMap.add(
  'OperatorReplica',
  $(
    go.Node,
    'Table',
    nodeStyle(),
    $(
      go.Panel,
      'Auto',
      $(
        go.Shape,
        'Rectangle', {
          desiredSize: new go.Size(160, 50),
          fill: 'transparent',
          stroke: '#17a2b8',
          strokeWidth: 1.5
        },
        new go.Binding('figure', 'figure')
      ),
      $(
        go.TextBlock,
        textStyle(), {
          margin: 8,
          maxSize: new go.Size(160, NaN),
          wrap: go.TextBlock.WrapFit,
          editable: true
        },
        new go.Binding('text').makeTwoWay()
      )
    ),
    makePort('T', go.Spot.Top, go.Spot.TopSide, false, true),
    makePort('L', go.Spot.Left, go.Spot.LeftSide, true, true),
    makePort('R', go.Spot.Right, go.Spot.RightSide, true, true),
    makePort('B', go.Spot.Bottom, go.Spot.BottomSide, true, false)
  )
)

//!------шаблон для реплики клиента
myDiagram.nodeTemplateMap.add(
  'ClientReplica',
  $(
    go.Node,
    'Table',
    nodeStyle(),
    $(
      go.Panel,
      'Auto',
      $(
        go.Shape,
        'Rectangle', {
          desiredSize: new go.Size(160, 50),
          fill: 'transparent',
          stroke: '#c3c8cc',
          strokeWidth: 1.5
        },
        new go.Binding('figure', 'figure')
      ),
      $(
        go.TextBlock,
        textStyle(), {
          margin: 8,
          maxSize: new go.Size(160, NaN),
          wrap: go.TextBlock.WrapFit,
          editable: true
        },
        new go.Binding('text').makeTwoWay()
      )
    ),
    // four named ports, one on each side:
    makePort('T', go.Spot.Top, go.Spot.TopSide, false, true),
    makePort('L', go.Spot.Left, go.Spot.LeftSide, true, true),
    makePort('R', go.Spot.Right, go.Spot.RightSide, true, true),
    makePort('B', go.Spot.Bottom, go.Spot.BottomSide, true, false)
  )
)

//! -------шаблон блока с условием
 myDiagram.nodeTemplateMap.add(
  'Conditional',
  $(
    go.Node,
    'Table',
    nodeStyle(),
    $(
      go.Panel,
      'Auto',
      $(
        go.Shape,
        'Diamond',
        { fill: 'transparent', stroke: '#00A9C9', strokeWidth: 1.5 },
        new go.Binding('figure', 'figure')
      ),
      $(
        go.TextBlock,
        textStyle(),
        {
          margin: 8,
          maxSize: new go.Size(160, NaN),
          wrap: go.TextBlock.WrapFit,
          editable: true
        },
        new go.Binding('text').makeTwoWay()
      )
    ),
    makePort('T', go.Spot.Top, go.Spot.Top, false, true),
    makePort('L', go.Spot.Left, go.Spot.Left, true, true),
    makePort('R', go.Spot.Right, go.Spot.Right, true, true),
    makePort('B', go.Spot.Bottom, go.Spot.Bottom, true, false)
  )
)

//!----------шаблон блока Старт
myDiagram.nodeTemplateMap.add(
  'Start',
  $(
    go.Node,
    'Table',
    nodeStyle(),
    $(
      go.Panel,
      'Spot',
      $(go.Shape, 'Circle', {
        desiredSize: new go.Size(90, 90),
        fill: 'transparent',
        stroke: '#007bff',
        strokeWidth: 1.5
      }),
      $(
        go.TextBlock,
        'Start',
        textStyle(), {
          wrap: go.TextBlock.WrapFit,
          textAlign: 'center',
          maxSize: new go.Size(90, NaN)
        },
        new go.Binding('text')
      )
    ),
    makePort('L', go.Spot.Left, go.Spot.Left, true, false),
    makePort('R', go.Spot.Right, go.Spot.Right, true, false),
    makePort('B', go.Spot.Bottom, go.Spot.Bottom, true, false)
  )
)

//!----------шаблон блока Конец
myDiagram.nodeTemplateMap.add(
  'End',
  $(
    go.Node,
    'Table',
    nodeStyle(),
    $(
      go.Panel,
      'Spot',
      $(go.Shape, 'Circle', {
        desiredSize: new go.Size(90, 90),
        fill: 'transparent',
        stroke: '#28a745',
        strokeWidth: 1.5
      }),
      $(
        go.TextBlock,
        'End',
        textStyle(), {
          wrap: go.TextBlock.WrapFit,
          textAlign: 'center',
          maxSize: new go.Size(90, NaN)
        },
        new go.Binding('text')
      )
    ),
    makePort('T', go.Spot.Top, go.Spot.Top, false, true),
    makePort('L', go.Spot.Left, go.Spot.Left, false, true),
    makePort('R', go.Spot.Right, go.Spot.Right, false, true)
  )
)

//!-----конструктор кастомных фигур
go.Shape.defineFigureGenerator('File', function(shape, w, h) {
  var geo = new go.Geometry()
  var fig = new go.PathFigure(0, 0, true) // starting point
  geo.add(fig)
  fig.add(new go.PathSegment(go.PathSegment.Line, 0.75 * w, 0))
  fig.add(new go.PathSegment(go.PathSegment.Line, w, 0.25 * h))
  fig.add(new go.PathSegment(go.PathSegment.Line, w, h))
  fig.add(new go.PathSegment(go.PathSegment.Line, 0, h).close())
  var fig2 = new go.PathFigure(0.75 * w, 0, false)
  geo.add(fig2)
  fig2.add(new go.PathSegment(go.PathSegment.Line, 0.75 * w, 0.25 * h))
  fig2.add(new go.PathSegment(go.PathSegment.Line, w, 0.25 * h))
  geo.spot1 = new go.Spot(0, 0.25)
  geo.spot2 = go.Spot.BottomRight
  return geo
})

//!------шаблон комментария
/*   myDiagram.nodeTemplateMap.add(
  'Comment',
  $(
    go.Node,
    'Auto',
    nodeStyle(),
    $(go.Shape, 'File', {
      fill: 'transparent',
      stroke: '#DEE0A3',
      strokeWidth: 1.5
    }),
    $(
      go.TextBlock,
      textStyle(),
      {
        margin: 8,
        maxSize: new go.Size(200, NaN),
        wrap: go.TextBlock.WrapFit,
        textAlign: 'center',
        editable: true
      },
      new go.Binding('text').makeTwoWay()
    )
  )
) */

//!------шаблон для ссылок
myDiagram.linkTemplate = $(
  go.Link, {
    routing: go.Link.AvoidsNodes,
    curve: go.Link.JumpOver,
    corner: 5,
    toShortLength: 4,
    relinkableFrom: true,
    relinkableTo: true,
    reshapable: true,
    resegmentable: true,
    mouseEnter: function(e, link) {
      link.findObject('HIGHLIGHT').stroke = 'rgba(30,144,255,0.2)'
    },
    mouseLeave: function(e, link) {
      link.findObject('HIGHLIGHT').stroke = 'transparent'
    },
    selectionAdorned: false
  },
  new go.Binding('points').makeTwoWay(),
  $(
    go.Shape, {
      isPanelMain: true,
      strokeWidth: 8,
      stroke: 'transparent',
      name: 'HIGHLIGHT'
    }
  ),
  $(
    go.Shape, {
      isPanelMain: true,
      stroke: 'gray',
      strokeWidth: 2
    },
    new go.Binding('stroke', 'isSelected', function(sel) {
      return sel ? 'dodgerblue' : 'gray'
    }).ofObject()
  ),
  $(
    go.Shape, {
      toArrow: 'standard',
      strokeWidth: 0,
      fill: 'gray'
    }
  ),
  $(
    go.Panel,
    'Auto', {
      visible: false,
      name: 'LABEL',
      segmentIndex: 2,
      segmentFraction: 0.5
    },
    new go.Binding('visible', 'visible').makeTwoWay(),
    $(
      go.Shape,
      'RoundedRectangle', {
        fill: '#F8F8F8',
        strokeWidth: 0
      }
    ),
    $(
      go.TextBlock,
      'Yes', {
        textAlign: 'center',
        font: '10pt helvetica, arial, sans-serif',
        stroke: '#333333',
        editable: true
      },
      new go.Binding('text').makeTwoWay()
    )
  )
)
//!-------ярлыки для ссылок от блока-условия
function showLinkLabel(e) {
  var label = e.subject.findObject('LABEL')
  if (label !== null)
    label.visible = e.subject.fromNode.data.category === 'Conditional'
}

myDiagram.toolManager.linkingTool.temporaryLink.routing = go.Link.Orthogonal
myDiagram.toolManager.relinkingTool.temporaryLink.routing = go.Link.Orthogonal

load()

//!-----боковая панель с элементами скрипта
var myPalette = $(
  go.Palette,
  'paletteBlock', {
    'animationManager.initialAnimationStyle': go.AnimationManager.None,
    InitialAnimationStarting: animateFadeDown,

    nodeTemplateMap: myDiagram.nodeTemplateMap,
    model: new go.GraphLinksModel([{
        category: 'Start',
        text: 'Начало разговора'
      },
      {
        category: 'OperatorReplica',
        text: 'Реплика оператора'
      },
      {
        category: 'ClientReplica',
        text: 'Реплика клиента'
      },
      {
        category: 'End',
        text: 'Конец разговора'
      },
      {
        category: 'Conditional',
        text: 'Условие'
      }
    ])
  }
)
//!------анимации
function animateFadeDown(e) {
  var diagram = e.diagram
  var animation = new go.Animation()
  animation.isViewportUnconstrained = true
  animation.easing = go.Animation.EaseOutExpo
  animation.duration = 900
  animation.add(
    diagram,
    'position',
    diagram.position.copy().offset(0, 200),
    diagram.position
  )
  animation.add(diagram, 'opacity', 0, 1)
  animation.start()
}

//! Данные для построения начального графика

function printDiagram() {
  var svgWindow = window.open()
  if (!svgWindow) return
  var printSize = new go.Size(700, 960)
  var bnds = myDiagram.documentBounds
  var x = bnds.x
  var y = bnds.y
  while (y < bnds.bottom) {
    while (x < bnds.right) {
      var svg = myDiagram.makeSVG({
        scale: 1.0,
        position: new go.Point(x, y),
        size: printSize
      })
      svgWindow.document.body.appendChild(svg)
      x += printSize.width
    }
    x = bnds.x
    y += printSize.height
  }
  setTimeout(function() {
    svgWindow.print()
  }, 1)
}

function load() {
  myDiagram.model = go.Model.fromJson(scriptData)
}


// this.updateModel(this.modelData)

return myDiagram

} // end of init



// WEBPACK FOOTER //
// ./src/diagram.js